import React from 'react';
import { Icon } from './Icons.jsx';
import { formatPercent, formatValue } from '../lib/format.js';

function Row({ label, metric, unit }) {
  if (!metric) return null;
  const stateLabel =
    metric.severity === 'critical' ? '超限' : metric.severity === 'warning' ? '告警' : '稳定';
  return (
    <div className="check-row">
      <div className="check-label">
        <span>{label}</span>
        <small>{metric.mode === 'conserved' ? '理论守恒' : '耗散已计入'}</small>
      </div>
      <div className="check-bar">
        <span
          className={`check-fill ${metric.severity}`}
          style={{ width: `${Math.max(2, Math.min(100, (metric.defect / 0.03) * 100))}%` }}
        />
      </div>
      <div className="check-value">
        <b>{formatValue(metric.current, 3)}</b>
        <span>{unit}</span>
        <em>{formatPercent(metric.defect, 3)}</em>
      </div>
      <span className={`check-state ${metric.severity}`}>{stateLabel}</span>
    </div>
  );
}

export function ConservationCard({ snapshot, selfTest, onOpenDiagnostics }) {
  const report = snapshot.conservation;
  const level = report.level;
  const title = level === 'critical' ? '守恒误差超限' : level === 'warning' ? '误差接近阈值' : '守恒校验通过';
  const subtitle =
    level === 'critical'
      ? 'Agent 已尝试回滚并细化步长'
      : level === 'warning'
        ? '已自动减小积分步长'
        : '动量与能量处于容差范围内';
  const icon = level === 'ok' ? 'shield' : 'alert';

  return (
    <div className={`conservation-summary ${level}`}>
      <div className="summary-head">
        <div className={`summary-icon ${level}`}>
          <Icon name={icon} size={22} />
        </div>
        <div>
          <div className="eyebrow">CONSERVATION WATCH</div>
          <h3>{title}</h3>
          <p>{subtitle}</p>
        </div>
        <button type="button" className="icon-btn small" onClick={onOpenDiagnostics} title="打开诊断面板">
          <Icon name="terminal" size={17} />
        </button>
      </div>

      <div className="check-rows">
        <Row label="机械能" metric={report.energy} unit="J" />
        <Row label="总动量" metric={report.momentum} unit="kg·m/s" />
        {!report.energy && !report.momentum && <p className="muted-copy">当前模型无守恒量监测项。</p>}
      </div>

      <div className="summary-foot">
        <span>
          <Icon name="cpu" size={13} />
          步长 {(1 / snapshot.fixedDt).toFixed(0)} Hz
        </span>
        <span>
          <Icon name="shield" size={13} />
          自检 {selfTest ? `${selfTest.summary.passed}/${selfTest.summary.total}` : '—'}
        </span>
        <span className={snapshot.repairs > 0 ? 'repair-text' : ''}>
          <Icon name="refresh" size={13} />
          自愈 {snapshot.repairs}
        </span>
      </div>
    </div>
  );
}
